import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SIDE_MENU_CONSTANTS } from '../../../constants/sidemenu.cnst';
import { SideMenuItem, SideMenuSection } from '../../../models/proj.model';
import { AppStateService, KeycloakService } from 'usermgmt';

@Component({
  selector: 'app-sidemenu',
  imports: [CommonModule, RouterModule, ButtonModule, TooltipModule],
  templateUrl: './sidemenu.html',
})
export class Sidemenu {
  @Input() isOpen = true;
  @Output() toggle = new EventEmitter<void>();

  private router = inject(Router);
  private appStateSrv = inject(AppStateService);

  userFullName = signal(this.deriveFullName(this.appStateSrv.getUserInfoFromLocalStorage()));

  constructor(private readonly keyCloakService: KeycloakService) {
    this.appStateSrv.userInfoRef
      .pipe(takeUntilDestroyed())
      .subscribe((userInfo) => this.userFullName.set(this.deriveFullName(userInfo)));
  }

  private deriveFullName(userObj: any): string {
    if (!userObj) {
      return '';
    }
    const firstName = userObj?.firstName || '';
    const lastName = userObj?.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || userObj?.username || '';
  }

  menuItems: SideMenuSection[] = SIDE_MENU_CONSTANTS.MENU_ITEMS;

  bottomMenuItems: any[] = [];

  isItemActive(item: SideMenuItem): boolean {
    const currentUrl = this.router.url;
    const route = item.route ?? item.link ?? '';
    if (route === '/digital-library') {
      return currentUrl.startsWith('/digital-library') ||
        currentUrl.startsWith('/station-data') ||
        currentUrl.startsWith('/assets-validation') ||
        currentUrl.startsWith('/assets-data') ||
        currentUrl.startsWith('/asset-viewer');
    }
    if (route === '/') {
      return currentUrl === '/';
    }
    return route ? currentUrl.startsWith(route) : false;
  }

  onLogout() {
    this.keyCloakService.logout();
  }
}
